/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IDialogProps } from '@fluentui/react/lib/Dialog';
import { Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { withModalMounter } from 'src/core/utils/hocs/withModalMounter';
import { MigrationModalFooter } from 'src/verticals/azureMigrationModal/newComponents/MigrationModalFooter';

const messages = defineMessages({
    title: {
        id: 'multiRegionMigrationModal.finishScreen.title',
        defaultMessage: 'Summary'
    },
    note: {
        id: 'multiRegionMigrationModal.finishScreen.note',
        defaultMessage: `You have migrated your apps successfully! After you click "Finish",
the page will refresh and you can select which Azure subscription you want to work in.`
    },
    migration: {
        id: 'multiRegionMigrationModal.finishScreen.migration',
        defaultMessage: 'migration'
    },
    subscription: {
        id: 'multiRegionMigrationModal.finishScreen.subscription',
        defaultMessage: 'Subscription: '
    },
    resourceGroup: {
        id: 'multiRegionMigrationModal.finishScreen.resourceGroup',
        defaultMessage: 'Resource group: '
    },
    resourceName: {
        id: 'multiRegionMigrationModal.finishScreen.resourceName',
        defaultMessage: 'Resource name: '
    }
});

/**
 * Renders the finishing screen of the migration flow. This
 * means that the user has successfully migrated.
 */
export const FinishScreen = withModalMounter((props: IDialogProps) => {
    const { onDismiss } = props;
    const { localize } = useLocalization();

    return (
        <Stack verticalFill tokens={{ childrenGap: 20 }}>
            <Stack verticalFill tokens={{ childrenGap: 20 }}>
                <LuisText variant="xLarge" fontWeight={600}>
                    {localize(messages.title)}
                </LuisText>
                <LuisText lineHeight="1.5">{localize(messages.note)}</LuisText>
            </Stack>

            <MigrationModalFooter backDisabled nextDisabled finishDisabled={false} onSubmit={onDismiss} />
        </Stack>
    );
});
